/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseListGroupHeading.vue?vue&type=template&id=3d256d67"
import script from "./BaseListGroupHeading.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseListGroupHeading.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseListGroupHeading.vue?vue&type=style&index=0&id=3d256d67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports